<ion-modal
  id="holidayPopupModal"
  [isOpen]="isOpen"
  [showBackdrop]="false"
  [backdropDismiss]="false"
>
  <ng-template>
    <!-- Snowfall effect -->
    <div class="snowfall" [class.stopped]="!isPlaying">
      <div
        *ngFor="let flake of snowflakes"
        class="snowflake"
        [ngStyle]="getSnowflakeStyle(flake)">
      </div>
    </div>

    <!-- Header with logo and close button -->
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <div class="holiday-popup__header">
          <ion-icon
            class="holiday-popup__logo"
            src="assets/Vessel_logo.svg"
            alt="Vessel logo">
          </ion-icon>
          <button class="holiday-popup__close-btn" (click)="close()">
            <ion-icon name="home-outline"></ion-icon>
          </button>
        </div>
      </ion-toolbar>
    </ion-header>

    <!-- Content area -->
    <ion-content class="holiday-popup__content">
      <div class="holiday-popup__content-inner">
        <!-- Building illustration -->
        <div class="holiday-popup__illustration">
          <img src="assets/holiday/building-sketch.png" alt="Building illustration" />
        </div>

        <!-- Holiday selection dropdown -->
        <div class="holiday-popup__dropdown">
          <label class="holiday-popup__dropdown-label">What are you celebrating?</label>
          <select
            class="holiday-popup__dropdown-select"
            [(ngModel)]="selectedHoliday">
            <option *ngFor="let option of holidayOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <!-- Play/Stop buttons -->
        <div class="holiday-popup__controls">
          <button
            class="holiday-popup__btn holiday-popup__btn--play"
            [class.active]="isPlaying"
            (click)="play()">
            <ion-icon name="play"></ion-icon>
            <span>{{ showPlayingText ? 'Playing' : 'Play' }}</span>
          </button>
          <button
            class="holiday-popup__btn holiday-popup__btn--stop"
            [class.active]="!isPlaying"
            (click)="stop()">
            <ion-spinner *ngIf="isStopping" name="crescent"></ion-spinner>
            <ion-icon *ngIf="!isStopping" name="stop"></ion-icon>
            <span>{{ isStopping ? 'Stopping' : 'Stop' }}</span>
          </button>
        </div>

        <!-- Holiday message -->
        <div class="holiday-popup__message">
          <p class="holiday-popup__greeting">Happy Holidays</p>
          <p class="holiday-popup__from">from</p>
          <ion-icon
            class="holiday-popup__brand-logo"
            src="assets/Vessel_logo.svg"
            alt="Vessel">
          </ion-icon>
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
